import React, { useContext, useEffect, useState } from "react";
import { Container } from "react-bootstrap";
import Accordion from "react-bootstrap/Accordion";
import Table from "react-bootstrap/Table";
import Wrapper from "../Helpers/Wrapper";
import AuthContext from "../store/auth-context";
import Row from "react-bootstrap/Row";
import Login from "../components/Login";
import Spinner from "react-bootstrap/Spinner";



const EventsAlpha = () => {
  const eventsUrl = "/apps3.php";
  const [eventsObj, setEventsObj] = useState();
  const [showSpinner, setShowSpinner] = useState(true);
  const [dataLoader, setDataLoader] = useState(false);
  const authCtx = useContext(AuthContext);
  var days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  const monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

  const hideSpinner = () => {
    setShowSpinner(false);
    const frame = document.getElementById('dynamic-frame');
    // frame.contentWindow.postMessage('contentWindow.body.scrollHeight', '*');
    console.log(`This is an event: ${JSON.stringify(frame.contentWindow.body.scrollHeight)}`)
    
    // myFrame.style.height = myFrame.contentWindow.document.body.scrollHeight + 'px';
  };

  function isInThePast(date) {
    const today = new Date();
    const theDate = new Date(date);
  
    return theDate < today;
  }

  function compareValues(key, order = 'asc') {
    return function innerSort(a, b) {
      if (!a.hasOwnProperty(key) || !b.hasOwnProperty(key)) {
        // property doesn't exist on either object
        return 0;
      }
  
      const varA = (typeof a[key] === 'string')
        ? a[key].toUpperCase() : a[key];
      const varB = (typeof b[key] === 'string')
        ? b[key].toUpperCase() : b[key];
  
      let comparison = 0;
      if (varA > varB) {
        comparison = 1;
      } else if (varA < varB) {
        comparison = -1;
      }
      return (
        (order === 'desc') ? (comparison * -1) : comparison
      );
    };
  }

  useEffect(() => {
    const dataFetch = async () => {
      // console.log(await fetch(eventsUrl));
      const data = await (await fetch(eventsUrl)).json();
      // console.log(`This is the data before json: ${JSON.stringify(data)}`);

      const dateData = data.map(obj => {
        return {...obj, event_date: new Date(obj.event_date)}
      })

      const sortedAsc = dateData.sort(
        (objA, objB) => objA.full_name.localeCompare(objB.full_name) || Number(objA.event_date) - Number(objB.event_date),
        // (objA, objB) => objA.full_name < objB.full_name || objA.event_date.toDateString().localCompare(objB.event_date.toDateString()),
      );

      // console.log(`This is the data after sorting: ${JSON.stringify(sortedAsc)}`);


      setEventsObj(sortedAsc);
      // setEventsObj(data.sort(compareValues('full_name')));
      setDataLoader(true);
      // console.log(`This is the event data: ${JSON.stringify(data)}`);
    };
    dataFetch();
  },[]);

  function nthNumber(number){
    if (number > 3 && number < 21) return `${number}th`;
    switch (number % 10) {
      case 1:
        return `${number}st`;
      case 2:
        return `${number}nd`;
      case 3:
        return `${number}rd`;
      default:
        return `${number}th`;
    }
  };

  function eventDate(eventDate){
    let date = new Date(eventDate);
    let currEventDate = new Date(date.getTime() + date.getTimezoneOffset() * 60000);
    let eventWeekDay = days[currEventDate.getDay()];
    let eventMonth = monthNames[currEventDate.getMonth()];
    let eventYear = currEventDate.getFullYear();
    let eventDayofMonth = currEventDate.getDate();
    return `${eventWeekDay}, ${eventMonth} ${nthNumber(eventDayofMonth)}, ${eventYear}`;
    // return new Date(date.getTime() + date.getTimezoneOffset() * 60000).toDateString()
  }

  


  return (
    <Container>
      {authCtx.isLoggedIn ? (
        <>
        <Container className="py-2 mb-3">
          {/* <Row>
            <h4 className="text-decoration-underline fst-italic">Events with Open Registration</h4>
          </Row> */}
        <Row>
          {!dataLoader ? showSpinner : 
          (!eventsObj ? 
          <div className="text-center">
            <h2>Currently there are no events open for registration.</h2>
          </div>
          : undefined)
          }
        <Accordion defaultActiveKey={["0", "1"]}>
          {eventsObj?.map((event) => (
            !isInThePast(event.reg_close_date) ? 
            <Accordion.Item eventKey={event.event_id}>
            <Accordion.Header>
              {/* <strong>{event.full_name} on {new Date(event.event_date.replace(/-/g, '/')).toDateString()}</strong> */}
              {/* <strong>{event.full_name} on {new Date(event.event_date + date.getTimezoneOffset() * 60000).toDateString()}</strong> */}
              <strong>{event.full_name} on {eventDate(event.event_date)}</strong>
            </Accordion.Header>
            <Accordion.Body>
              <Table responsive="lg">
                <tbody>
                  <tr>
                    <div className="text-center">Registration deadline: {new Date(event.reg_close_date.replace(/-/g, '/')).toDateString()}</div>
                  </tr>
                  <tr>
                  {event.isOnline ? 
                    <div className="text-center"><a href={`https://msmta.org/registration/regMain.php?event_id=${event.event_id}`} target="_blank" rel="noreferrer">Register Here</a></div>
                    : 
                    <div className="text-center">
                      <p className="fw-bold">This event doesn't have online registration. Please open the event rules below for submission information.</p>
                    </div>
                  }
                  </tr>
                  <tr>
                    {event.infoFilename ? 
                    <div className="text-center"><a href={`/${event.infoFilename}`}  target="_blank" rel="noreferrer">Event Rules and Regulations</a></div> : undefined }
                  </tr>
                </tbody>
              </Table>
            </Accordion.Body>
            </Accordion.Item> : undefined
          ))}
        </Accordion>
        </Row>
        </Container>
        {/* <Container className="py-2 mb-3">
          <Row>
            <h4 className="text-decoration-underline fst-italic">Events with Closed Registration</h4>
          </Row> */}
        {/* <Row> */}
        {/* <Accordion defaultActiveKey={["0", "1"]}>
          {eventsObj?.map((event) => (
            isInThePast(event.reg_close_date) ?
              <Accordion.Item eventKey={event.event_id}>
                <Accordion.Header>
                  <strong>{event.full_name} on {new Date(event.event_date.replace(/-/g, '/')).toDateString()}</strong>
                </Accordion.Header>
                <Accordion.Body>
                <Table responsive="lg">
                  <tbody>
                    <tr>
                      <div className="text-center">Registration deadline: {new Date(event.reg_close_date.replace(/-/g, '/')).toDateString()}</div>
                    </tr>
                    <tr>
                      <div className="text-center">Registration for this event is closed</div> 
                    </tr>
                    <tr>
                      {event.infoFilename ? 
                      <div className="text-center"><a href={`/${event.infoFilename}`}  target="_blank" rel="noreferrer">Event Rules and Regulations</a></div> : undefined }
                    </tr>
                  </tbody>
                </Table>
              </Accordion.Body> 
              </Accordion.Item>: undefined
            
          ))}
        </Accordion> */}
        {/* </Row> */}
        {/* </Container> */}
        </>
      ) : (
        <Wrapper>
          <h3>
            Please <Login handleLogin={authCtx.onLogin} /> to continue to the
            events!
          </h3>
        </Wrapper>
      )}
    </Container>
  );
};

export default EventsAlpha;
